import { PageContainer, PageContainerProps } from '@ant-design/pro-layout';
import { FC, useEffect, useState } from 'react';
import { ItemType } from 'antd/es/breadcrumb/Breadcrumb';
import routeNames from '../modules/router/src/routeNames';
import TaggedLink from './TaggedLink';

interface CustomPageContainerOwnProps extends PageContainerProps {
  breadcrumbName: string;
  prevRoute?: ItemType[];
}

const CustomPageContainer: FC<CustomPageContainerOwnProps> = (props) => {
  const {
    title, breadcrumbName, children, prevRoute,
  } = props;

  const [breadcrumbsRoutes, setBreadcrumbsRoutes] = useState<ItemType[]>([]);

  useEffect(() => {
    const tempRouteArr: ItemType[] = [];
    tempRouteArr.push({
      path: routeNames.dashboard,
      title: 'Home',
    });
    if (prevRoute) {
      prevRoute.forEach((route) => {
        tempRouteArr.push(route);
      });
    }
    tempRouteArr.push({
      path: '',
      title: breadcrumbName,
    });
    setBreadcrumbsRoutes(tempRouteArr);
  }, [prevRoute, breadcrumbName]);

  return (
    <PageContainer
      header={{
        title,
        ghost: true,
        breadcrumb: {
          items: breadcrumbsRoutes,
          itemRender: (route: any) => {
            if (route.path) {
              return (
                <TaggedLink to={route.path} tag={route.path}>
                  {route.title}
                </TaggedLink>
              );
            }
            return route.title;
          },
        },
      }}
    >
      {children}
    </PageContainer>
  );
};

CustomPageContainer.defaultProps = {
  prevRoute: [],
};

export default CustomPageContainer;
